export const shareActions = [
  {
    name: 'design',
    groupLayout: 'topBottom',
    config: {
      设计: ['title_textTheme', 'title_fontFamily', 'title_fontSize', 'title_color', 'title_textStyle']
    }
  },
  'translate',
  'isShow'
]
